import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { apiGet, apiPost, getToken, setToken } from './api';
const Ctx = createContext(null);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    // Bootstrap: se tem token, valida + busca user
    useEffect(() => {
        const t = getToken();
        if (!t) {
            setLoading(false);
            return;
        }
        apiGet('/auth/me')
            .then(r => setUser(r.user))
            .catch(() => setToken(null))
            .finally(() => setLoading(false));
        const onUnauth = () => setUser(null);
        window.addEventListener('cglogs:unauthorized', onUnauth);
        return () => window.removeEventListener('cglogs:unauthorized', onUnauth);
    }, []);
    const login = useCallback(async (email, password) => {
        const r = await apiPost('/auth/login', { email, password });
        setToken(r.token);
        setUser(r.user);
    }, []);
    const logout = useCallback(async () => {
        try {
            await apiPost('/auth/logout', {});
        }
        catch { /* noop */ }
        setToken(null);
        setUser(null);
    }, []);
    return _jsx(Ctx.Provider, { value: { user, loading, login, logout }, children: children });
}
export function useAuth() {
    const ctx = useContext(Ctx);
    if (!ctx)
        throw new Error('useAuth must be inside AuthProvider');
    return ctx;
}
